function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import DatePicker from 'integration-web-core--socle/js/assets/modules/_datePicker.class.js';
import datePickerTemplate from '../template/d-datePicker';
var DesktopPicker = /*#__PURE__*/function () {
  function DesktopPicker() {
    _classCallCheck(this, DesktopPicker);
  }
  return _createClass(DesktopPicker, [{
    key: "initializeStartDatePicker",
    value: function initializeStartDatePicker(searchModule, min, max) {
      searchModule.startDatePicker = new DatePicker({
        element: '.js-startDatePicker',
        dateFormat: 'd/m/Y',
        minDate: new Date(min),
        maxDate: new Date(max),
        disableMobile: 'true',
        /*"disable": [
        //Un array permettant de désactiver certaines dates, une fonction est utilisable, ici on va désactiver la possibilité de choisir les weekends
                  function(date) {
                      // return true to disable weekend
                      return (date.getDay() === 6 || date.getDay() === 0);
                  }
              ],*/
        onValueUpdate: function onValueUpdate() {
          if (searchModule.endDatePicker !== null && searchModule.endDatePicker.dateValue !== '') {
            searchModule.endDatePicker = null;
            searchModule.endHourPicker = null;
          }
          searchModule.submitSearch('start');
        }
      });
    }
  }, {
    key: "initializeEndDatePicker",
    value: function initializeEndDatePicker(searchModule, min, max, endDateTemplate) {
      var startElement = document.querySelector('.js-startDate');
      if (document.querySelector('.js-endDate') === null) {
        startElement.insertAdjacentHTML('afterend', lm.template(endDateTemplate));
      }
      var endElement = document.querySelector('.js-endDate');
      if (endElement.querySelector('input.js-endDatePicker') === null) {
        endElement.insertAdjacentHTML('beforeend', lm.template(datePickerTemplate, {
          name: 'endDatePicker',
          label: 'Choisissez une date de retour'
        }));
      } else {
        endElement.querySelector('.js-endDatePicker').removeAttribute('disabled');
      }
      searchModule.endDatePicker = new DatePicker({
        element: '.js-endDatePicker',
        dateFormat: 'd/m/Y',
        minDate: new Date(min),
        maxDate: new Date(max),
        disableMobile: 'true',
        /*"disable": [
        //Un array permettant de désactiver certaines dates, une fonction est utilisable, ici on va désactiver la possibilité de choisir les weekends
                  function(date) {
                      // return true to disable weekend
                      return (date.getDay() === 6 || date.getDay() === 0);
                  }
              ],*/
        onValueUpdate: function onValueUpdate() {
          //Si l'on doit faire un traitement une fois la date changée par l'utilisateur
          if (searchModule.endHourPicker !== null && searchModule.endHourPicker.hourValue !== '') {
            searchModule.endHourPicker = null;
          }
          searchModule.submitSearch('end');
        }
      });
    }
  }, {
    key: "setPickers",
    value: function setPickers(searchModule, dates, hours) {
      searchModule.startDatePicker.dateValue = dates.start;
      searchModule.endDatePicker.dateValue = dates.end;
      searchModule.startHourPicker.parameters.hour.start = hours.start.substring(0, 5);
      searchModule.startHourPicker.createHourSelector();
      searchModule.startHourPicker.hourValue = hours.start.substring(0, 5);
      searchModule.endHourPicker.parameters.hour.start = hours.end.substring(0, 5);
      searchModule.endHourPicker.createHourSelector();
      searchModule.endHourPicker.hourValue = hours.end.substring(0, 5);
    }
  }, {
    key: "setStartDate",
    value: function setStartDate(searchModule, date) {
      searchModule.startDatePicker.dateValue = date;
    }
  }, {
    key: "setEndDate",
    value: function setEndDate(searchModule, date) {
      searchModule.endDatePicker.dateValue = date;
    }
  }]);
}();
export default DesktopPicker;